import React from 'react';

interface LogoBackgroundProps extends React.SVGProps<SVGSVGElement> {
    color?: string;
}

const StavarioLogoBackground: React.FC<LogoBackgroundProps> = ({ color = '#fbfbfb', ...props }) => {
    const originalSizeW = 359;
    const originalSizeH = 476;

    return (
        <svg
            width="100vw"
            height="100vh"
            viewBox={`0 0 ${originalSizeW} ${originalSizeH}`}
            preserveAspectRatio="xMidYMid slice"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M331.553 476a26.844 26.844 0 019.042-15.527l18.4-18.487V476zm-158.658 0c53.744-53.535 114.516-114.209 145.145-145.262a30.217 30.217 0 0121.429-10.611 27.236 27.236 0 0119.53 8.286v38.359q-.785.832-1.642 1.6c-23.732 21.7-71.715 69.216-110.134 107.623zm-172.9 0V32.682l19.048-18.99a27.256 27.256 0 0138.507 0 27.7 27.7 0 010 38.926L31.29 78.833a27.155 27.155 0 00-7.413 23.162v.962a9.727 9.727 0 00.409 1.61 26.661 26.661 0 0029 20.675 27.172 27.172 0 0016.515-8.047L180.829 6.454A27.152 27.152 0 01193.195 0h12.016a27.178 27.178 0 0114.129 44.816L30.325 233.744a27.1 27.1 0 0021.915 46.164 27.658 27.658 0 0016.6-8.039l41.971-41.828a27.586 27.586 0 0118.536-6.992 27.207 27.207 0 0127.23 27.183 31.654 31.654 0 01-12.488 23.486L34.599 384.063a26.956 26.956 0 1038.105 38.124l37.944-37.724a27.133 27.133 0 0138.438 37.885l-53.709 53.651zm166.89-136.738a27.234 27.234 0 1127.23 27.19 27.212 27.212 0 01-27.226-27.19zm91.77-37.477a27.013 27.013 0 01-17.884-47.452l118.228-118.166V214.7c-29.951 30.5-65.5 65.955-84.226 81.941a24.2 24.2 0 01-14.959 5.171c-.383 0-.769-.009-1.154-.027zm-91.369-116.7a27.242 27.242 0 017.9-19.3l65.02-64.906a27.207 27.207 0 1138.505 38.354L249.87 168.11l-22.477 22.354s-9.5 9.333-12.566 12.629a27.913 27.913 0 01-20.3 9.171 27.213 27.213 0 01-27.236-27.178z"
                fill={color}
            />
        </svg>
    );
};

export default StavarioLogoBackground;
